import { useContext } from "react";
import { BrandAuthContext } from "../contexts/BrandAuthContext/context";

export const useBrandAuth = () => {
  const context = useContext(BrandAuthContext);
  if (!context) {
    throw new Error("useBrandAuth must be used within a BrandAuthProvider");
  }
  return context;
}; 